import TwitterOnboardingPage from './TwitterOnboardingPage';

export default TwitterOnboardingPage;
